import {
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
  Grid,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import db from "../../../db/db";
import { StringUtils } from "../../../utils/StringUtils";
import PendingChequeCrud from "./PendingChequeCrud";
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function PendingChequesList(props) {
  const { t } = useTranslation();
  const translate = t;
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showCrud, setShowCrud] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const [selectedRowType, setselectedRowType] = useState("");
  const [chequeStatus, setChequeStatus] = useState("");
  const [chequeFilter, setChequeilter] = useState("");
  const [rowLimitPerPage, setRowLimitPerPage] = useState(
    Math.round((getWindowDimensions().height - 155) / 32)
  );

  useEffect(() => {
    loadData("PENDING");
  }, []);

  function PendingChequeListRefresh() {
    loadData("PENDING");
  }

  function onPostClicked(row) {
    setShowCrud(true);
    setSelectedRow(row.tableData[row.rowIndex].id);
    setselectedRowType(row.tableData[row.rowIndex].type);
    setChequeStatus(row.tableData[row.rowIndex].chequeStatus);
  }

  async function loadData(chequeStatus) {
    let search = "[]";
    if (chequeStatus) {
      let str = "[";
      str +=
        '{id:"chequeStatus",value:"' +
        chequeStatus +
        '",regExp:"",matchType:"EXACT_MATCH",operatorType:"",fieldValueType:"string"}]';
      search = str;
    }
    loadByRest(0, rowLimitPerPage, "[]", search);
  }
  async function loadByRest(curPage, pageSize, sort, filter) {
    setIsLoading(false);
    sort = '[{id:"transactionDate2",desc:true}]';
    const result = await API.get(
      "/api/v1/getPendingChequeList/Bank?range=" +
        encodeURIComponent(
          "[" + curPage * pageSize + "," + ((curPage + 1) * pageSize - 1) + "]"
        ) +
        "&filter=" +
        encodeURIComponent(filter) +
        "&sort=" +
        encodeURIComponent(sort)
    );

    var arr = result.headers["content-range"].split("/");

    const opt = { ...option };
    opt.count = parseInt(arr[2]);
    setOption(opt);
    setData(result.data);
    setIsLoading(false);
  }

  async function onTableChange(tableState) {
    let sort = "[]";
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    let search = "[]";

    if (tableState.filterList) {
      let str = "[";
      str = str + '{id:"type",value:"' + tableState.filterList[4] + '"}';
      // str =
      //   str + ',{id:"chequeStatus",value:"' + tableState.filterList[8] + '"}';
      str = str + "]";
      search = str;
    }

    if (tableState.searchText) {
      let str = "[";
      str = str + '{id:"fromLedgerName",value:"' + tableState.searchText + '"}';
      str = str + ',{id:"toLedgerName",value:"' + tableState.searchText + '"}';
      str = str + ',{id:"voucherNumber",value:"' + tableState.searchText + '"}';
      str = str + ',{id:"chequeNo",value:"' + tableState.searchText + '"}';
      str = str + ',{id:"amount",value:"' + tableState.searchText + '"}';
      str = str + "]";
      search = str;
    }
    loadByRest(tableState.page, tableState.rowsPerPage, sort, search);
  }

  const options = {
    serverSide: true,
    filterType: "dropdown",
    download: false,
    viewColumns: false,
    filter: true,
    filterType: "dropdown",
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyHeight: getWindowDimensions().height - 162,
    rowsPerPage: Math.round((getWindowDimensions().height - 162) / 33),
    rowsPerPageOptions: [
      Math.round((getWindowDimensions().height - 162) / 33),
      10,
      15,
      50,
      100,
    ],
    print: false,
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want
      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "sort":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
        case "search":
          onTableChange(tableState);
          break;
        case "filterChange":
          onTableChange(tableState);
          break;
        default:
        //console.log("action not handled." + action);
      }
    },
  };

  const [option, setOption] = useState(options);

  const columns = [
    {
      name: "voucherNumber",
      label: translate("Voucher Number"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "transactionDate2",
      label: translate("Transaction Date"),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return StringUtils.formatDate(new Date(value), 1);
        },
      },
    },
    {
      name: "chequeNo",
      label: translate("Cheque No"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "chequeDate",
      label: translate("Cheque Date"),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value === null) {
            return "";
          } else {
            return StringUtils.formatDate(new Date(value), 1);
          }
        },
      },
    },
    {
      name: "type",
      label: translate("Type"),
      options: {
        filter: true,
        sort: false,
        filterOptions: {
          names: ["CUSTOMER", "VENDOR", "Payment", "Receipt"],
        },
      },
    },
    {
      name: "fromLedger",
      label: translate("From"),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value.name;
        },
      },
    },
    {
      name: "toLedger",
      label: translate("To"),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value.name;
        },
      },
    },

    {
      name: "amount",
      label: translate("Amount"),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value < 0 ? (
            <div>
              {StringUtils.formattedNumber(
                value * -1,
                props.context.store.currencyDecimal
              )}
            </div>
          ) : (
            <div>
              {StringUtils.formattedNumber(
                value * 1,
                props.context.store.currencyDecimal
              )}
            </div>
          );
        },
      },
    },
    {
      name: "chequeStatus",
      label: translate("Cheque Status"),
      options: {
        filter: false,
        sort: false,
        // filterOptions: {
        //   names: ["PENDING", "CLEARED"],
        // },
      },
    },
    {
      name: "action",
      label: translate("Actions"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({ align: "right" }),
        setCellProps: () => ({ align: "right" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <Button
            onClick={() => onPostClicked(tableMeta, updateValue, value)}
            color="secondary"
            style={{
              margin: 0,
              padding: 0,
              height: 17,
              width: 27,
              alignText: "right",
            }}
          >
            {tableMeta.tableData[tableMeta.rowIndex].chequeStatus ==
              "PENDING" && props.context.privileges.post_pending_cheques
              ? "POST"
              : "VIEW"}
          </Button>
        ),
      },
    },
  ];
  return (
    <Grid container>
      <Grid item xs={12}>
        <div>
          <MUIDataTable
            title={
              <Typography variant="h6">
                {"Pending Cheque List"}
                {isLoading && (
                  <CircularProgress
                    size={24}
                    style={{ marginLeft: 15, position: "relative", top: 4 }}
                  />
                )}
              </Typography>
            }
            data={data}
            columns={columns}
            options={option}
          />
        </div>
      </Grid>
      {showCrud && (
        <PendingChequeCrud
          setShowCrud={setShowCrud}
          context={props.context}
          selectedRow={selectedRow}
          showMessage={props.showMessage}
          selectedRowType={selectedRowType}
          chequeStatus={chequeStatus}
          onRefresh={PendingChequeListRefresh}
        ></PendingChequeCrud>
      )}
    </Grid>
  );
}
